import {
  physicalWorldEnabled,
  PHYSICAL_WORLD_TERMINALS_ACTIONS_ENUM,
  PHYSICAL_WORLD_ORDERS_ACTIONS_ENUM
} from '@/actions-permission/physical-world.permissions'

import { isPhysical } from '@/enums/business-model.enum.js'
import { isPhysicalWorldTerminalRouteVisible } from '@/enums/physical-world.enum'

const PHYSICAL_WORLD = ({ permissionIsEnabled, routeName, businessModel }) => ({
  key: 'physical-world',
  label: 'sidemenu.physical-world',
  showSection:
    isPhysical(businessModel) && physicalWorldEnabled(permissionIsEnabled),
  items: {
    terminals: {
      label: 'sidemenu.submenu.physical-world.terminals',
      showItem: permissionIsEnabled(
        PHYSICAL_WORLD_TERMINALS_ACTIONS_ENUM.search
      ),
      active: isPhysicalWorldTerminalRouteVisible(routeName)
    },
    'service-orders': {
      label: 'sidemenu.submenu.physical-world.service-orders',
      showItem: permissionIsEnabled(PHYSICAL_WORLD_ORDERS_ACTIONS_ENUM.search),
      active: ['service-orders', 'serviceOrdersDetail'].some(
        route => routeName === route
      )
    }
  }
})

export default PHYSICAL_WORLD
